<script>
  export let selectedCountries;
  export let numCountry;
  export let countries;
  

  $: selectedCountry = selectedCountries[numCountry]

  const setSelectedCountry = (e) => {
    selectedCountries[numCountry] = e.target.value;
  };
</script>

<div class="interactive__options--dropdown">
  <label for="{`country-${numCountry}`}" class="sr-only">Select Year:</label>
  <select id="{`country-${numCountry}`}" class={`input__select ${numCountry == 0 ? 'color--primary' : 'color--secondary'}`} value={selectedCountry} on:change={(e) => setSelectedCountry(e)}>
    {#each [...countries] as [key, value]}
      <option value={key} 
      >{value.country}</option>
    {/each}
  </select>
</div>

<style type="text/scss">
  @import "../scss/components/_form-elements.scss";
</style>